module.exports = __webpack_public_path__ + "static/media/revenge-of-the-sith.238b2edb.png";